import React, { useCallback } from 'react';
import { Filter } from '../../../Enum/Filters';
import { Form } from 'react-bootstrap';
import { filterChanged } from '../../../Store/Filter/action';

import { useDispatch } from 'react-redux';
import useGetFilterValue from '../../../Hook/Interest/UseGetFilterValue';

const MIN_RISK_CATEGORY = 50;
const MAX_RISK_CATEGORY = 110;
const RISK_CATEGORY_STEP = 5;

const RiskCategoryFilter: React.FC = () => {
    const dispatch = useDispatch();
    const value = useGetFilterValue(Filter.RiskCategory);

    const selectRiskCategory = useCallback(
        (riskCategory: string): void => {
            dispatch(filterChanged(Filter.RiskCategory, riskCategory));
        },
        [dispatch],
    );

    const riskCategories: number[] = [];
    for (let category = MIN_RISK_CATEGORY; category <= MAX_RISK_CATEGORY; category += RISK_CATEGORY_STEP) {
        riskCategories.push(category);
    }

    return (
        <Form className="risk-category-filter" autoComplete="off">
            <Form.Group controlId="risk_category">
                <Form.Label>Marktwaardepercentage</Form.Label>
                <Form.Control
                    as="select"
                    custom
                    value={value as string}
                    onChange={e => selectRiskCategory(e.currentTarget.value)}
                >
                    {riskCategories.map(riskCategory => (
                        <option value={riskCategory} key={riskCategory}>
                            {riskCategory}%
                        </option>
                    ))}
                </Form.Control>
            </Form.Group>
        </Form>
    );
};

export default RiskCategoryFilter;
